(function (angular) {
    'use strict';

    angular.module('app').config(config);

    config.$inject = ['$stateProvider'];

    // TODO: Este estado sólo vale para páginas estáticas en HTML, pero no para BD.

    function config($stateProvider) {
        $stateProvider.state('estatica', {
            parent: 'site',
            url: '/estatica/:id',
            params: {
                language: ['Language',
                    function (Language) {
                        return Language.getCurrent();
                    }
                ]
            },
            data: {
                authorities: []
            },
            // FIXME: Se puede comprobar si existe la página? En caso de que no exista, apuntar a una que sí. Si no, la página se queda en blanco sin dar error.
            views: {
                'content@': {
                    templateUrl: function (params) {
                        return 'estaticas/' + params.id + '/' + params.id + '.' + params.language + '.html';
                    }
                }
            }
        });
    }
})(angular);
